import React from 'react';
import classnames from 'classnames';
import { StrapiImageFragment } from '../../../graphql.schema';
import * as styles from '../HomepageHero/HomepageHero.module.scss';
type Props = {
  image: StrapiImageFragment;
  className: string;
  loading?: 'lazy' | 'eager';
  style?: { [key: string]: string };
  width?: number;
  height?: number;
};

type ImageUrlProps = {
  hash: string;
  format: 'xlarge' | 'large' | 'medium' | 'small' | 'thumbnail';
  ext: string;
};

const Image = ({ image, className, loading, style, width, height }: Props) => {
  const imageUrl = ({ hash, format, ext }: ImageUrlProps) => {
    const baseUrl = image.url?.slice(0, image.url.indexOf('/', 8));
    return `${baseUrl}/${format}_${hash}.${ext}`;
  };

  const getExt = () => {
    return image.url?.slice(image.url.indexOf('/', 8)).split('.')[1];
  };

  return (
    <picture data-testid="picture">
      {image?.formats?.xlarge ? (
        <>
          <source data-testid="xlarge-source"
            type={`image/${getExt()}`}
            srcSet={imageUrl({ hash: image?.hash, format: 'xlarge', ext: getExt() })}
            media="(min-width: 1920px)"
            width={image?.formats?.xlarge.width}
            height={image?.formats?.xlarge.height}
          />
        </>
      ) : null}
      {image?.formats?.large ? (
        <>
          <source data-testid="large-source"
            type={`image/${getExt()}`}
            srcSet={imageUrl({ hash: image?.hash, format: 'large', ext: getExt() })}
            media="(min-width: 1000px)"
            width={image?.formats?.large.width}
            height={image?.formats?.large.height}
          />
        </>
      ) : null}
      {image?.formats?.medium ? (
        <>
          <source data-testid="medium-source"
            type={`image/${getExt()}`}
            srcSet={imageUrl({ hash: image?.hash, format: 'medium', ext: getExt() })}
            media="(min-width: 750px)"
            width={image?.formats?.medium.width}
            height={image?.formats?.medium.height}
          />
        </>
      ) : null}
      {image?.formats?.small ? (
        <>
          <source data-testid="small-source"
            type={`image/${getExt()}`}
            srcSet={imageUrl({ hash: image?.hash, format: 'small', ext: getExt() })}
            media="(max-width: 750px)"
            width={image?.formats?.small?.width}
            height={image?.formats?.small?.height}
          />
        </>
      ) : null}
      <img
        data-testid="image"
        className={className}
        alt={image?.alternativeText ?? image?.caption ?? ''}
        width={width}
        height={height}
        loading={loading}
        style={style}
        src={image?.url}
      />
    </picture>
  );
};

export default Image;
